export const transformSizeDto = size => {
  const {
    id,
    title,
    order
  } = size;
  return {
    id,
    title,
    order,
    isDefault: !!size.is_default,
    isOther: !!size.is_other
  };
};
export const transformSizeDtos = sizes => sizes.map(transformSizeDto);